// EDIT 20•JAN•21 Teams' version
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const awsmobile = {
  aws_project_region: 'us-west-2',
  aws_cognito_identity_pool_id: 'us-west-2:002f5b1f-8a89-4d14-8fc2-d1d0e7e70217',
  aws_cognito_region: 'us-west-2',
  aws_user_pools_id: 'us-west-2_ZacDl14eQ',
  aws_user_pools_web_client_id: '6cdfr0ts5baa0pr0h8hdm9p67q',
  oauth: {
    domain:
      'flexwalletapi2-monectaauthbyemail-hosteduidomain-dev.auth.us-west-2.amazoncognito.com',
    scope: [
      'phone',
      'email',
      'openid',
      'profile',
      'aws.cognito.signin.user.admin',
    ],
    redirectSignIn: 'myapp://',
    redirectSignOut: 'myapp://',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cloud_logic_custom: [
    {
      name: 'profile-api',
      endpoint: 'https://0cei86bt9c.execute-api.us-west-2.amazonaws.com/dev',
      region: 'us-west-2',
    },
    {
      name: 'transaction-api',
      endpoint: 'https://7h6pvxe9rb.execute-api.us-west-2.amazonaws.com/dev',
      region: 'us-west-2',
    },
    {
      name: 'credit-api',
      endpoint: 'https://ct8fkfo4m2.execute-api.us-west-2.amazonaws.com/dev',
      region: 'us-west-2',
    },
    {
      name: 'event-api',
      endpoint: 'https://vj3663n5uj.execute-api.us-west-2.amazonaws.com/dev',
      region: 'us-west-2',
    },
    {
      name: 'inventory-api',
      endpoint: 'https://9j8g6f96h1.execute-api.us-west-2.amazonaws.com/dev',
      region: 'us-west-2',
    },
    {
      name: 'invitation-api',
      endpoint: 'https://3svbnyqb4a.execute-api.us-west-2.amazonaws.com/dev',
      region: 'us-west-2',
    },
    {
      name: 'invoice-api',
      endpoint: 'https://ygqikmrhe1.execute-api.us-west-2.amazonaws.com/dev',
      region: 'us-west-2',
    },
    {
      name: 'payment-api',
      endpoint: 'https://3m3u7syzy2.execute-api.us-west-2.amazonaws.com/dev',
      region: 'us-west-2',
    },
    {
      name: 'product-api',
      endpoint: 'https://cqm1qzvr57.execute-api.us-west-2.amazonaws.com/dev',
      region: 'us-west-2',
    },
    {
      name: 'setting-api',
      endpoint: 'https://kwxd0w39di.execute-api.us-west-2.amazonaws.com/dev',
      region: 'us-west-2',
    },
    {
      name: 'store-api',
      endpoint: 'https://gzw5lp413l.execute-api.us-west-2.amazonaws.com/dev',
      region: 'us-west-2',
    },
    {
      name: 'merchant-api',
      endpoint: 'https://6c6gw2nri1.execute-api.us-west-2.amazonaws.com/dev',
      region: 'us-west-2',
    },
    {
      name: 'inshop-api',
      endpoint: 'https://haxh1vnzsg.execute-api.us-west-2.amazonaws.com/dev',
      region: 'us-west-2',
    },
    {
      name: 'keys-api',
      endpoint: 'https://lafqahl9aa.execute-api.us-west-2.amazonaws.com/dev',
      region: 'us-west-2',
    },
    {
      name: 'funds-api',
      endpoint: 'https://v6432fs6xd.execute-api.us-west-2.amazonaws.com/dev',
      region: 'us-west-2',
    },
    {
      name: 'notifications-push-api',
      endpoint: 'https://o8zl144afa.execute-api.us-west-2.amazonaws.com/dev',
      region: 'us-west-2',
    },
    {
      name: 'speis-api',
      endpoint: 'https://x2myd08u5i.execute-api.us-west-2.amazonaws.com/dev',
      region: 'us-west-2',
    }
  ],
  aws_appsync_graphqlEndpoint: 'https://7n42op3hc5d55nnswvvlprygum.appsync-api.us-west-2.amazonaws.com/graphql',
  aws_webSocket_Endpoint: 'wss://j183zm3na0.execute-api.us-west-2.amazonaws.com/dev',
  aws_appsync_region: 'us-west-2',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_user_files_s3_bucket: 'flexwalletapi2-bucket-dev-us-west-2',
  aws_user_files_s3_bucket_region: 'us-west-2',
};

export default awsmobile;